// extracted by mini-css-extract-plugin
module.exports = {"SArticleRowBlock":"VerticalArticleListBlock_SArticleRowBlock__Pu6D0"};